/*
  Contract-badge injector for Searchanise-rendered result cards (per-code tag).

  Runs on any page that hosts Searchanise (collection, search, autocomplete).
  Match rule: a card qualifies when it carries a CSS class matching ANY of the
  customer's contract-collection codes. Searchanise renders each product tag as
  a class of the form `snize-product-tag-<lowercased-tag>`; since products are
  tagged `contract-{CODE}` (one tag per company code they belong to), the class
  we look for is `snize-product-tag-contract-{code.toLowerCase()}`.

  Firing conditions (ALL must be true):
    1. settings.bg_show is enabled                       (STATE.enabled)
    2. Customer is logged into a B2B company              (STATE.customerHasCompany)
    3. Customer's company has contract_collection code(s) (STATE.customerCodes)
    4. Card carries a class matching one of those codes

  Injection: overlay badge absolutely top-left of the card. Cards use a
  span-only inner tree (`.snize-overhidden`) with overflow-clipping, so an
  inline block-level insertion would be invalid HTML + get clipped.
*/
(function () {
  var STATE = window.__CCTN_CONTRACT_BADGE;
  if (!STATE || !STATE.enabled || !STATE.customerHasCompany) return;
  if (!Array.isArray(STATE.customerCodes) || STATE.customerCodes.length === 0) return;

  // Precompute the exact class strings to check per card.
  var MATCH_CLASSES = STATE.customerCodes
    .map(function (c) { return String(c || '').trim().toLowerCase(); })
    .filter(Boolean)
    .map(function (c) { return 'snize-product-tag-contract-' + c; });
  if (MATCH_CLASSES.length === 0) return;

  var BADGE_CLASS = 'contract-badge cctn-contract-badge-overlay';
  var MARK_ATTR   = 'data-cctn-badge-done';

  function makeBadge() {
    var div = document.createElement('div');
    div.className = BADGE_CLASS;
    div.style.cssText = [
      'position:absolute',
      'top:8px',
      'left:8px',
      'z-index:5',
      'background-color:' + (STATE.bg || '#3F72E5'),
      'color:' + (STATE.fg || '#FFFFFF'),
      'padding:4px 14px',
      'border-radius:5px',
      'font-size:11px',
      'font-weight:600',
      'letter-spacing:0.5px',
      'pointer-events:none',
      'text-transform:uppercase'
    ].join(';');
    var span = document.createElement('span');
    span.textContent = STATE.text || 'CONTRACT';
    div.appendChild(span);
    return div;
  }

  function cardMatches(card) {
    for (var i = 0; i < MATCH_CLASSES.length; i++) {
      if (card.classList.contains(MATCH_CLASSES[i])) return true;
    }
    return false;
  }

  function processCard(card) {
    if (!card || card.getAttribute(MARK_ATTR)) return;
    if (!cardMatches(card)) {
      card.setAttribute(MARK_ATTR, 'skip');
      return;
    }
    var currentPos = getComputedStyle(card).position;
    if (currentPos === 'static' || !currentPos) card.style.position = 'relative';
    card.appendChild(makeBadge());
    card.setAttribute(MARK_ATTR, 'done');
  }

  function scan() {
    document.querySelectorAll('.snize-product:not([' + MARK_ATTR + '])').forEach(processCard);
    document.querySelectorAll('.snize-search-preview-result:not([' + MARK_ATTR + '])').forEach(processCard);
    document.querySelectorAll('.snize-result:not([' + MARK_ATTR + '])').forEach(processCard);
  }

  var observer = new MutationObserver(function () { scan(); });
  observer.observe(document.body, { childList: true, subtree: true });

  var pollId = setInterval(scan, 700);
  window.addEventListener('beforeunload', function () { clearInterval(pollId); observer.disconnect(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
})();
